import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import VisitCounter from '../components/commons/VisitCounter';

const Footer = () => {
  return (
    <Container as="footer" className="py-5">
      <Row>
        {/* Columna de información */}
        <Col md={6} className="mb-3" data-aos="fade-up">
          <h5>Fundación Colegio Santo Tomás</h5>
          <ul className="nav flex-column">
            <li className="nav-item mb-2">
              <a href="tel:+542954313911" className="nav-link p-0 text-body-secondary">
                📞 +54 2954 313911
              </a>
            </li>
            <li className="nav-item mb-2">
              <a
                href="https://www.fundacioncolegiosantotomas.com.ar"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link p-0 text-body-secondary"
              >
                🌐 www.fundacioncolegiosantotomas.com.ar
              </a>
            </li>
            <li className="nav-item mb-2">
              <a
                href="mailto:administracion@fundacioncolegiosantotomas.com.ar"
                className="nav-link p-0 text-body-secondary"
              >
                📧 administracion@fundacioncolegiosantotomas.com.ar
              </a>
            </li>
            <li className="nav-item mb-2">
              <span className="nav-link p-0 text-body-secondary">
                📍 La Pampa, Santa Rosa – Santiago del Estero 666
              </span>
            </li>
            <li className="nav-item mb-2">
              <Button variant="link" className="p-0 text-body-secondary">
                👥 Nosotros
              </Button>
            </li>
          </ul>
        </Col>

        {/* Formulario de suscripción */}
        <Col md={{ span: 5, offset: 1 }} className="mb-3" data-aos="fade-down">
          <Form>
            <h5>Ingresa tu correo y nosotros te contactamos.</h5>
            <p>Nos adaptamos a las necesidades de tu familia.</p>
            <div className="d-flex flex-column flex-sm-row w-100 gap-2">
              <Form.Control
                type="email"
                placeholder="Correo electrónico"
                className="me-sm-2"
              />
              <Button type="button">Enviar</Button>
            </div>
          </Form>
        </Col>
      </Row>

      {/* Redes y WhatsApp */}
      <Row className="text-center mt-4">
        <Col md={6} className="mb-3">
          <h5>Seguinos en nuestras redes</h5>
          <div className="d-flex justify-content-center gap-4 fs-3">
            <a
              href="https://www.instagram.com/santotomassr/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-danger"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/santotomasinstitucional"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
          </div>
        </Col>
        <Col md={6} className="mb-3">
          <h5>Escribinos por WhatsApp</h5>
          <p className="mb-0">
            <a
              href="https://wa.me/5492954313911"
              target="_blank"
              rel="noopener noreferrer"
              className="text-success text-decoration-none fs-5"
            >
              <FaWhatsapp className="me-2" />
              +54 9 2954 313911
            </a>
          </p>
        </Col>
      </Row>

      {/* Créditos */}
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 py-4 my-4 border-top">
        <p className="mb-0">© 2025 Fundación Colegio Santo Tomás.</p>
        <VisitCounter />
      </div>
    </Container>
  );
};

export default Footer;
